export default {"src":"/_next/static/media/newsletter-divider.cea713ac.svg","height":154,"width":1280};